module.exports = __webpack_public_path__ + "static/media/safari-pinned-tab.1b506f82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saleschannel-favicon/safari-pinned-tab.svg
// module id = 276
// module chunks = 0